export const loginAdapters = {
  transformForApi: (data) => {
    return {
      login: data.login,
      password: data.password,
    };
  },
};
